import { render, staticRenderFns } from "./sharemessage-popup.vue?vue&type=template&id=84eed87e&"
import script from "./sharemessage-popup.vue?vue&type=script&lang=js&"
export * from "./sharemessage-popup.vue?vue&type=script&lang=js&"
import style0 from "./sharemessage-popup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports